import { Stack, StackItem, TableHeader } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { ShiftTransactionsTable } from '../tables/shiftTransactions/ShiftTransactionsTable';
import { ShiftOverviewTable } from '../tables/ShiftOverviewTable';
import { PastShiftDetailsTable } from '../tables/PastShiftDetailsTable';

interface Props {
    shiftId: string;
}

export const PastShiftPage = ({ shiftId }: Props) => (
    <Stack distribution="stretch" vertical spacing="500">
        <StackItem>
            <TableHeader title={lt('CashierShiftShiftDetails')} />
            <PastShiftDetailsTable shiftId={shiftId} />
        </StackItem>
        <StackItem>
            <TableHeader title={lt('CashierShiftShiftBalanceSummary')} />
            <ShiftOverviewTable shiftId={shiftId} />
        </StackItem>
        <StackItem>
            <ShiftTransactionsTable shiftId={shiftId} />
        </StackItem>
    </Stack>
);
